import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Fade from '@mui/material/Fade';
import Logo from '../Res/csal-logo.svg';
import BgImage from '../Res/bg.jpg';
import LoginForm from '../Components/LoginForm';
import Langue from '../Components/Langue';
import Mode from '../Components/Mode';
import { useTranslation } from 'react-i18next';
import SetCookie from '../Components/Hooks/Cookies/SetCookie';
import GetCookie from '../Components/Hooks/Cookies/GetCookie';
import Data from "../Data/Data.json";

export default function Login() {
  const cookieMode = GetCookie(Data.LocalVariable.mode);
  const { t } = useTranslation();
  const [mode, setmode] = React.useState(cookieMode ? cookieMode.toString() : () => {
    SetCookie(Data.LocalVariable.mode, 'light');
    return "light";
  });

  const isLight = mode === 'light';

  return (
    <Fade in={true} timeout={1000}>
      <Box
        className="full"
        sx={{
          height: '100%',
          position: 'absolute',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: `url(${BgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            // background: 'linear-gradient(135deg, rgba(8,35,56, 0.88) 0%, rgba(0, 0, 0, 0.72) 100%)',
            zIndex: 0,
          },
        }}
      >
        {/* Contrôles haut droite */}
        <Box
          sx={{
            position: 'absolute',
            top: { xs: 8, sm: 16 },
            right: { xs: 8, sm: 16 },
            display: 'flex',
            gap: { xs: 1, sm: 1.5 },
            zIndex: 10,
          }}
        >
          <Langue />
          <Mode />
        </Box>

        {/* Carte de connexion centrée */}
        <Container
          maxWidth="sm"
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: { xs: 2, sm: 4 },
            px: { xs: 1, sm: 2 },
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Box
            className="fade-in"
            sx={{
              background: isLight
                ? 'rgba(255, 255, 255, 0.57)'
                : 'rgba(16, 24, 22, 0.96)',
              borderRadius: { xs: '12px', sm: '24px' },
              p: { xs: 2, sm: 3, md: 2 },
              width: '100%',
              maxWidth: { xs: '100%', sm: 460 },
              boxShadow: isLight
                ? '0 24px 70px rgba(0, 0, 0, 0.18), 0 10px 30px rgba(0, 0, 0, 0.08)'
                : '0 24px 70px rgba(0, 0, 0, 0.55), 0 10px 30px rgba(0, 0, 0, 0.3)',
              textAlign: 'center',
              transition: 'all 0.4s ease',
              '&:hover': {
                transform: { sm: 'translateY(-4px)' },
                boxShadow: isLight
                  ? '0 32px 80px rgba(0, 0, 0, 0.22), 0 14px 36px rgba(0, 0, 0, 0.1)'
                  : '0 32px 80px rgba(0, 0, 0, 0.65), 0 14px 36px rgba(0, 0, 0, 0.35)',
              },
            }}
          >
            <center><img src={Logo} alt="Logo" style={{ width: '100px', height: '100px' }} /></center>
            {/* <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '1.75rem', sm: '2.5rem' },
                fontWeight: 800,
                letterSpacing: '0.8px',
                background: 'linear-gradient(135deg, #116599 0%, #0d4a70 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                mb: 0.5,
              }}
            >
              cSAL
            </Typography> */}
            {/* <Typography
              variant="body2"
              sx={{
                color: isLight ? '#5a6a78' : '#9db0bd',
                fontWeight: 400,
                fontSize: { xs: '0.95rem', sm: '1rem' },
                mb: 4,
              }}
            >
              {t("texte.bienvenue")}
            </Typography> */}
            <LoginForm mode={isLight ? "light" : "dark"} />
          </Box>
        </Container>

        {/* Copyright */}
        <Box
          sx={{
            textAlign: 'center',
            py: 2,
            position: 'relative',
            zIndex: 2,
            color: 'rgba(255,255,255,0.75)',
            fontSize: '0.85rem',
            px: 2,
          }}
        >
          {t("texte.copyright")}
        </Box>
      </Box>
    </Fade>
  );
}
